import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useLanguage } from '../../i18n';
import '../../styles/ModalStyles.css';

interface GameModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  content: string;
  onConfirm?: () => void;
  showConfirmButton?: boolean;
}

const GameModal: React.FC<GameModalProps> = ({
  show,
  onHide,
  title,
  content,
  onConfirm,
  showConfirmButton = false
}) => {
  const { t } = useLanguage();

  // 处理确认按钮点击
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="kcd-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{content}</p>
      </Modal.Body>
      <Modal.Footer className="game-modal-footer">
        {showConfirmButton ? (
          <div className="modal-buttons-container">
            <Button variant="kcd" className="kcd-button kcd-button-primary" onClick={handleConfirm}>
              {t('confirm')}
            </Button>
            <Button variant="kcd" className="kcd-button" onClick={onHide}>
              {t('cancel')}
            </Button>
          </div>
        ) : (
          <Button variant="kcd" className="kcd-button" onClick={onHide}>
            {t('ok')}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default GameModal;
